import { rest } from 'msw';
import { importMoreProductsResponse } from './importMoreProducts';

export const importMoreProductHandler = [
    rest.post('*submittal/:bom_id/:packageType', (_req: any, res, ctx) => {
        return res(ctx.delay(2000), ctx.json(importMoreProductsResponse));
    })
];
